// extracted by mini-css-extract-plugin
export default {"button":"rX4Lprt9JGluPd+43d4Ezg==","loader":"icxX1BDKUPm9Bo+F5Hlj6g==","opacity":"yTjAIhgy1uBp9erXV2Ni8A=="};